import { render, staticRenderFns } from "./agv-kind-list.vue?vue&type=template&id=12f6e1e0&scoped=true&lang=pug&"
import script from "./agv-kind-list.vue?vue&type=script&lang=js&"
export * from "./agv-kind-list.vue?vue&type=script&lang=js&"
import style0 from "./agv-kind-list.vue?vue&type=style&index=0&id=12f6e1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f6e1e0",
  null
  
)

export default component.exports